import { render, staticRenderFns } from "./ProjectEdit.vue?vue&type=template&id=13cc0332&scoped=true&"
import script from "./ProjectEdit.vue?vue&type=script&lang=js&"
export * from "./ProjectEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProjectEdit.vue?vue&type=style&index=0&id=13cc0332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cc0332",
  null
  
)

export default component.exports